/**
 * How well agents choose when to answer a comment (RFC 0324 3g).
 *
 * Measured one way, off the project's comments and never stored as a count:
 * questions nobody answered. A reply nobody needed has no honest automatic
 * measure, so the person says so when it happens.
 */

import { projectThreads } from './reads'
import type { CommentEntry } from './types'

const DAY = 24 * 60 * 60 * 1000

/** A comment that asks something: a question mark, or a session named. */
export function asksSomething(comment: CommentEntry): boolean {
  if (comment.body.includes('?')) return true
  return (comment.mentions ?? []).some((m) => m.kind === 'session')
}

/**
 * Open threads whose last comment is a person's, asks something, and got
 * neither a reply nor a pass within a day. "Stayed quiet when it should not
 * have": this should fall toward zero.
 */
export function unansweredQuestions(
  projectDoc: unknown,
  now: number = Date.now(),
): CommentEntry[] {
  const out: CommentEntry[] = []
  for (const t of projectThreads(projectDoc)) {
    if (t.root.resolved) continue
    const last = t.replies[t.replies.length - 1] ?? t.root
    if (last.authorSessionId) continue
    if (!asksSomething(last)) continue
    if (now - last.createdAt < DAY) continue
    if (Object.keys(last.readBy ?? {}).length > 0) continue
    out.push(last)
  }
  return out
}
